import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { Game } from './types';

interface GameCardProps {
  game: Game;
  index: number;
}

export const GameCard: React.FC<GameCardProps> = ({ game, index }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (game.name === 'Factor Detective') {
      navigate('/games/factor-detective');
    } else if (game.name === 'Money Manager') {
      navigate('/games/money-manager');
    } else if (game.name === 'Algebra Adventures') {
      navigate('/games/algebra-adventures');
    } else if (game.name === 'Measure Master') {
      navigate('/games/measure-master');
    }
  };
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: index * 0.1 }}
      className="relative aspect-video bg-[#EE5E37] rounded-[33px] p-6 flex flex-col justify-end cursor-pointer hover:scale-105 transition-transform"
      onClick={handleClick}
    >
      <div className="space-y-2">
        <p className="text-white text-xl font-medium">{game.name}</p>
        <p className="text-white/75 text-sm">{game.description}</p>
        <div className="flex items-center space-x-2">
          <div 
            className="w-2 h-2 rounded-full"
            style={{ backgroundColor: game.color }}
          />
          <span className="text-white/75 text-sm">{game.subject}</span>
        </div>
      </div>
      <div className="absolute right-6 bottom-6 w-[84px] h-[84px] bg-black rounded-full flex items-center justify-center">
        <div className="w-0 h-0 border-l-[20px] border-l-white border-y-[12px] border-y-transparent ml-2" />
      </div>
    </motion.div>
  );
};